import Enum from 'cg-enum'

const locationEnum = new Enum(
  ['threeLesson', 'literacy', 'liveThematic', 'liveLongTerm'],
  -26
)

export const CourseLocation = {
  [locationEnum.liveLongTerm]: 1,
  [locationEnum.liveThematic]: 2,
  [locationEnum.literacy]: 3,
  [locationEnum.threeLesson]: 4,
  0: 5
}

export const courseTypeNameCH = {
  [locationEnum.liveLongTerm]: '同步课程', // 同步课
  [locationEnum.liveThematic]: '专题课程', // 专题课
  [locationEnum.literacy]: '素养课程', // 素养课程
  [locationEnum.threeLesson]: '三节课', // 三节课
  0: ''
}



// WEBPACK FOOTER //
// ./src/defines/locationEnum.js